import { CurrentOperatorAction } from '../actions/CurrentOperatorAction'
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initState = {
    requestBody: {
        sectionId: "CurrentOperator",
        steps: [
            {
                sequence: "0",
                offerContainerId: "",
                stepId: "CurrentOperator",
                fields: [
                    {
                        name: "CurrentOperator",
                        value: ""
                    }
                ]
            }
        ]
    },
}

const CurrentOperatorReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    let currentValue = { ...state.requestBody.steps };

    switch (type) {
        case CurrentOperatorAction.SELECT_OPERATOR:
            currentValue[0].fields[0].value = payload.selection;
            currentValue[0].offerContainerId = payload.offerContainerId;
            return state;

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'CurrentOperator')
            });
            if (section.length > 0) {
                currentValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                let currentOperater = section[0].steps[0].fields[0];
                currentValue[0].fields[0].value = currentOperater ? currentOperater.value : "";
            }
            return state;

        default:
            return state;
    }
}

export default CurrentOperatorReducer;